var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-5",attrs:{"id":"page-shortlink"}},[(_vm.ok === true)?_c('m-row',[_c('m-col',{attrs:{"lg":"12"}},[_c('div',{staticClass:"text-center"},[_c('span',[_vm._v("Du har avregistrerat dig från framtida SMS utskick!")])])])],1):_vm._e(),_c('m-row',[_c('m-col',{attrs:{"lg":"12"}},[_c('span',[_vm._v("Ett fel uppstod")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }